"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const NEW_BTN_HEIGHT = 24;
const styles = (theme) => ({
    buttonContainer: {
        marginLeft: 16,
        marginRight: 'auto',
        alignSelf: 'center',
        lineHeight: `${NEW_BTN_HEIGHT}px`,
    },
    title: {
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    searchContainer: {
        marginLeft: 'auto',
        marginRight: '0px',
        alignSelf: 'center',
        lineHeight: '32px',
        display: 'flex',
        alignItems: 'center',
    },
    smartSearch: {
        height: 'calc(100% - 1px)',
        marginTop: 0,
    },
    addTxnButton: {
        marginLeft: 8,
        minWidth: 40,
        width: 40,
        height: 40,
        borderRadius: '50%',
    },
    iconButton: {
        marginRight: 1,
        color: theme.palette.icon.secondary,
    },
    scheduleMenuHolder: {
        display: 'inline-block',
    },
    csvDownload: {
        marginLeft: 5,
        marginTop: 4,
        color: theme.palette.text.secondary,
    },
    container: {
        background: theme.palette.background.paper,
        display: 'flex',
        height: theme.mixins.register.controlBarHeight,
        paddingTop: 6,
        paddingBottom: 3,
    },
    filterIconButton: {
        '&:hover': {
            color: theme.palette.action.active,
        },
    },
    rightControls: {
        display: 'flex',
        borderRadius: 12,
        marginRight: 10,
        '&:focus-within': {
            borderColor: theme.palette.primary.main,
        },
    },
    searchBox: {
        padding: 1,
        border: `1px solid ${theme.palette.text.tertiary}`,
        borderRadius: '5px 0px 0px 5px',
        borderColor: theme.palette.text.tertiary,
        '&:focus-within': {
            borderColor: ` ${theme.palette.primary.main} !important`,
        },
        '&:hover': {
            borderColor: `${theme.palette.text.primary}`,
            color: theme.palette.primary.main,
        },
    },
    filterBox: {
        padding: 1,
        border: `1px solid ${theme.palette.text.tertiary}`,
        borderLeft: '0px solid',
        borderRadius: '0px 5px 5px 0px',
        '&:hover': {
            background: theme.palette.action.hoverLight,
        },
        display: 'flex',
    },
    searchMetrics: {
        display: 'inline-block',
        margin: 'auto 0 auto 17px',
        paddingTop: 4,
        color: theme.palette.text.primary,
    },
    searchHelpContainer: {
        padding: 20,
        background: theme.palette.background.subtle,
    },
    searchHelpTitle: {
        marginBottom: 2,
    },
    searchHelpSubtitle: {
        marginBottom: 3,
        marginTop: 3,
    },
    helpText: {
        marginBottom: 5,
    },
    filterNum: {
        whiteSpace: 'nowrap',
        padding: '1px 4px 0 3px',
        margin: 'auto 8px auto 0',
        textAlign: 'center',
        background: theme.palette.background.selected,
        color: theme.palette.text.primary,
        borderRadius: 5,
    },
    filterNumClose: {
        borderRadius: '50%',
        width: 14,
        height: 14,
        background: theme.palette.text.secondary,
        textAlign: 'center',
        left: -2,
        top: 2,
        position: 'relative',
        marginLeft: -10,
        cursor: 'pointer',
        '&:hover': {
            background: theme.palette.text.primary,
        },
    },
    filterNumCloseText: {
        fontSize: '10px',
        fontWeight: 500,
        color: theme.palette.text.contrastText,
    },
    circularProgress: {
        display: 'grid',
        color: theme.palette.grey[50],
    },
    iconDivider: {
        borderImage: `radial-gradient(${theme.palette.text.tertiary}, ${theme.palette.background.paper}) 1`,
        borderLeft: '1px solid',
        borderRight: '1px solid',
    },
});
exports.styles = styles;
